import SnappingSlider from './snapping-slider'
export withSnapPoint from './visibility-monitor'

export default SnappingSlider
